import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import marlena1 from "../../images/marlena/marlena1.webp";
import marlena2 from "../../images/marlena/marlena2.webp";
import styles from "./About.module.css";

const aboutPageInfo = {
  bio: `Marléna Mendoza is a tattooer and artist based out of Albuquerque, New Mexico. Marléna began tattooing in East Los Angeles before moving to the Southwest. She specializes in fineline black & grey, illustrative and ornamental tattoos. Marléna graduated from California College of the Arts in 2015 with a BFA in studio art. Her tattooing is heavily influenced by her background in printmaking, as well as her interest in botanicals, landscape, and the natural world at large.`,
  story: `Marléna was a fellow at Yerba Buena Center for the Arts in 2017, and her work has been exhibited in group shows in Oakland, Los Angeles and Albuquerque. Outside of tattooing she spends her other time working on regenerative gardening in her backyard, making ceramics and hugging her dog Millie.`,
};

const About = () => {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 28,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const fadeIn = {
    hidden: {
      opacity: 0,
      scale: 0.98,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 1,
        ease: "easeOut",
      },
    },
  };

  const viewport = {
    once: true,
    amount: 0.3,
  };

  return (
    <main className={styles.aboutContainer}>
      <section className={styles.hero}>
        <motion.div
          className={styles.heroImageWrapper}
          variants={fadeIn}
          initial="hidden"
          animate="visible"
        >
          <img
            src={marlena1}
            alt="Marléna Mendoza"
            className={styles.heroImage}
          />
        </motion.div>

        <motion.div
          className={styles.heroContent}
          variants={fadeUp}
          initial="hidden"
          animate="visible"
        >
          <h1 className={styles.aboutTitle}>
            About <span>Marléna</span>
          </h1>
          <p className={styles.heroBio}>{aboutPageInfo.bio}</p>
        </motion.div>
      </section>

      <section className={styles.storySection}>
        <motion.div
          className={styles.storyHeading}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
        >
          <span className={styles.headingLine} />
          <h2>
            Hi, I'm Marléna, a tattooer
            <span>and artist.</span>
          </h2>
        </motion.div>

        <div className={styles.storyGrid}>
          <motion.div
            className={styles.storyImageWrapper}
            variants={fadeIn}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
          >
            <img
              src={marlena2}
              alt="Marléna Mendoza"
              className={styles.storyImage}
            />
          </motion.div>

          <motion.div
            className={styles.storyContent}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
          >
            <span className={styles.storyEyebrow}>
              A little bit about my history and life
            </span>
            <p>{aboutPageInfo.story}</p>
          </motion.div>

          <motion.div
            className={styles.bookingSection}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
          >
            <span className={styles.bookingLabel}>Ready when you are.</span>
            <NavLink
              to="/inquiry"
              className={styles.bookingButton}
            >
              Book an Appointment
            </NavLink>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default About;